import React from "react";
import DashboardScreen from "../adminpanneldashboard/dashboard/screens/DashboardScreen";
import UserName from "../usernamebar/UserName";
import { Box, Flex } from "@chakra-ui/react";
const LayoutBuilder = ({ children }) => {
  return (
    <Flex direction={"row"} gap={5} p={3}>
      <DashboardScreen />

      <Flex direction={"column"} w={"100%"} h={"100%"} gap={4} flex={1}   overflow={"hidden"}>
        <UserName />
        <Box>{children}</Box>
      </Flex>
    </Flex>
  );
};

export default LayoutBuilder;
